mainApp.component('cloudAccessSettings', {
    templateUrl: '/public/components/cloudAccess/cloud-access-settings.component.html',
    controller: function($state, $scope, CloudAccessService, GeneralUtilsService, GlobalCloudApplicationAuthenticationService, UserContextService) {

        var ctrl = this;

        ctrl.type = "Domain";
        ctrl.SSOLoginEnabled = false;
        ctrl.defaultIpRange = "10.42.0.0/16";

        ctrl.fields = {
            from: {
                name: 'From',
                id: 'allowedDomains',
                types: [
                    {
                        name: ctrl.type,
                        field: {
                            component: "text",
                            type: ctrl.type,
                            validate: (item) => {
                                if (!item) {
                                    return "Enter domain name";
                                }
                                if (item.includes(";")) {
                                    return "Invalid domain name"
                                }
                            },
                            output: (item) => {
                                item = item.trim();
                                return {
                                    id: item,
                                    type: ctrl.type,
                                    display_name: item,
                                }
                            },
                            placeHolder: 'myDomain.com'
                        },
                    }
                ],
            }
        }

        var defaultCloudAccessSettings = {
            settings: {
                keepRealSourceIp: true,
                cookieExpirationTime: 1,
                cookieTimeType: "DAYS",
                cookiePersistant: true,
                portalEnabled: false,
            }
        }

        ctrl.$onInit = function() {
            ctrl.init();
        };

        ctrl.init = function() {
            ctrl.isSSOLoginEnabled();
            ctrl.getAccountCloudAccessSettings();
            ctrl.iconChanged = false;
        }

        ctrl.isViewer = function() {
            return UserContextService.isDisableGUI();
        };

        // required to show unsaved changes warning when switching to a different screen
        $scope.$root.hasChanges = function() {
            return ctrl.hasChanges();
        }

        ctrl.hasChanges = function() {
            return !angular.equals(ctrl.originalSettings, ctrl.settings) || ctrl.iconChanged;
        };

        ctrl.updateIconChanged = function(imageText, imageType) {
            ctrl.iconChanged = true;
            ctrl.settings.imageText = imageText;
            ctrl.settings.imageType = imageType;
        }

        ctrl.saveChanges = function() {
            if (ctrl.settings.isCookiePersistent) {
                if (!Number.isInteger(ctrl.settings.cookieDuration)) {
                    ctrl.cookieError = {status: "ERROR", message: "Invalid value for Duration", field: "cookieType"};
                } else if (ctrl.settings.cookieDuration > 2147483647 /* Integer.MAX_VALUE */) {
                    ctrl.cookieError = {status: "ERROR", message: "Duration is too large", field: "cookieType"};
                }
            }
            CloudAccessService.saveCloudAccessSettings($state.params.accountId, ctrl.miniAccount(), function (data) {
                $scope.$broadcast('stop-load');
                if (data.status == "OK") {
                    $scope.$root.handleServerResponse(data, "", "Settings saved successfully");
                    ctrl.cloudAccessConfiguration = data.model.cloudAccessConfiguration;
                    ctrl.initCloudAccessSettingsValues(ctrl.cloudAccessConfiguration);
                    ctrl.originalSettings = angular.copy(ctrl.settings);
                    ctrl.iconChanged = false;
                }
                else {
                    if (ctrl.cookieError) {
                        data.notifications.push(ctrl.cookieError);
                        delete ctrl.cookieError;
                    }
                    $scope.$root.handleServerResponse(data, '', '');
                }
            });

            $scope.$broadcast('modelSavedEvent');
        };

        ctrl.isSSOLoginEnabled = function(){
            CloudAccessService.isSSOLoginEnabled($state.params.accountId, function(data) {
                ctrl.SSOLoginEnabled = data;
            });
        }

        ctrl.getAccountCloudAccessSettings = function() {
            CloudAccessService.getCloudAccessSettings($state.params.accountId, function(data) {
                ctrl.settings = {};
                ctrl.cloudAccessConfiguration = data.cloudAccessConfiguration;
                ctrl.portalUrl = ctrl.cloudAccessConfiguration.fqdn;
                if (ctrl.cloudAccessConfiguration && ctrl.cloudAccessConfiguration.settings) {
                    ctrl.initCloudAccessSettingsValues(ctrl.cloudAccessConfiguration);
                } else {
                    ctrl.initCloudAccessSettingsValues(defaultCloudAccessSettings);
                    CloudAccessService.isApplicationIpRangeAvailable($state.params.accountId, function(data) {
                        if (data) {
                            ctrl.settings.ipCidr = ctrl.defaultIpRange;
                            ctrl.originalSettings.ipCidr = ctrl.defaultIpRange;
                        }
                    })
                }
                ctrl.readAccountData = true;
                ctrl.originalSettings = angular.copy(ctrl.settings);

                ctrl.initCompleted = true;
                $scope.$digest();
            });
        }

        ctrl.initCloudAccessSettingsValues = function(cloudAccessConfiguration) {
            ctrl.settings.keepRealSourceIp = cloudAccessConfiguration.settings.keepRealSourceIp;
            ctrl.settings.isCookiePersistent = cloudAccessConfiguration.settings.cookiePersistant;
            ctrl.settings.cookieDuration = cloudAccessConfiguration.settings.cookieExpirationTime;
            ctrl.settings.cookieTimeUnit = cloudAccessConfiguration.settings.cookieTimeType;
            ctrl.settings.allowedDomains = [];
            ctrl.settings.useCatoLogin = cloudAccessConfiguration.settings.useCatoLogin;
            ctrl.settings.imageText = cloudAccessConfiguration.settings.imageText;
            ctrl.settings.imageType = cloudAccessConfiguration.settings.imageType;
            ctrl.settings.portalEnabled = cloudAccessConfiguration.settings.portalEnabled;
            ctrl.settings.allowSSOLogin = cloudAccessConfiguration.settings.allowSSOLogin;
            if (cloudAccessConfiguration.settings.allowedDomains) {
                let allowedDomainsNames = cloudAccessConfiguration.settings.allowedDomains.split(';');
                allowedDomainsNames.forEach(name => ctrl.settings.allowedDomains.push({id: name, type: ctrl.type, display_name: name}));
            }
            if (cloudAccessConfiguration.settings.ipCidr) {
                ctrl.settings.ipCidr = cloudAccessConfiguration.settings.ipCidr;
            };
        }

        ctrl.miniAccount = function() {
            let account = {};
            account.id = $state.params.accountId;
            account.newSaveMethod = true;
            account.cloudAccessConfiguration = ctrl.cloudAccessConfiguration;
            if (!account.cloudAccessConfiguration) {
                // new config
                account.cloudAccessConfiguration = {};
                account.cloudAccessConfiguration.newSaveMethod = true;
                account.cloudAccessConfiguration.type = "CLOUDACCESSCONFIGURATION";
            }
            if (!account.cloudAccessConfiguration.settings) {
                // new settings with defaults
                account.cloudAccessConfiguration.settings = {};
                account.cloudAccessConfiguration.settings.id = GeneralUtilsService.getRandomId();
                account.cloudAccessConfiguration.settings.cookieExpirationTime = 1;
                account.cloudAccessConfiguration.settings.cookieTimeType = "DAYS";
                account.cloudAccessConfiguration.settings.cookiePersistant = true;
                account.cloudAccessConfiguration.settings.openAppInTab = true;
                account.cloudAccessConfiguration.settings.enforceIps = false;
                account.cloudAccessConfiguration.settings.enforceAv = true;
                account.cloudAccessConfiguration.settings.enforceNgAv = true;
                account.cloudAccessConfiguration.settings.trustedDestinations = true;
            }
            account.cloudAccessConfiguration.name = "CloudAccessConfiguration";
            account.cloudAccessConfiguration.settings.ipCidr = ctrl.settings.ipCidr;
            account.cloudAccessConfiguration.settings.keepRealSourceIp = ctrl.settings.keepRealSourceIp;
            account.cloudAccessConfiguration.settings.cookiePersistant = ctrl.settings.isCookiePersistent;
            account.cloudAccessConfiguration.settings.cookieExpirationTime = ctrl.settings.cookieDuration;
            account.cloudAccessConfiguration.settings.cookieTimeType = ctrl.settings.cookieTimeUnit;
            account.cloudAccessConfiguration.settings.imageText = ctrl.settings.imageText;
            account.cloudAccessConfiguration.settings.imageType = ctrl.settings.imageType;
            account.cloudAccessConfiguration.settings.portalEnabled = ctrl.settings.portalEnabled;
            account.cloudAccessConfiguration.settings.useCatoLogin = ctrl.settings.useCatoLogin;
            account.cloudAccessConfiguration.settings.allowSSOLogin = ctrl.settings.allowSSOLogin;


            let domains = '';
            let delimiter = '';
            ctrl.settings.allowedDomains.forEach(domain => {
                domains += delimiter;
                domains += domain.display_name;
                delimiter  = ';';
            });
            if (domains === '') {
                delete account.cloudAccessConfiguration.settings.allowedDomains;
            } else {
                account.cloudAccessConfiguration.settings.allowedDomains = domains;
            }
            return account;
        }
    }
});

